export default __webpack_public_path__ + "static/media/LockClosed.18281e85.png";